/*
  rgd-kit-catalogo.js — navegação do Catálogo de kits.

  Este arquivo NÃO monta kit nenhum. Cada painel da seção carrega
  data-rgd-kit-pronto e os data-rkp-*, então quem cuida de seleção de
  variante, resumo, revalidação de estoque e /cart/add.js continua sendo a
  classe RGDKitPronto (assets/rgd-kit-pronto.js), sem nenhuma cópia da
  matemática de desconto aqui.

  O que sobra para este arquivo: trocar a grade pelo painel e vice-versa,
  cuidar do foco nessa troca e voltar para a grade quando o carrinho
  confirmar a adição.
*/
(function () {
  'use strict';

  class RGDKitCatalogo {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-rkc-grid]');
      this.notice = root.querySelector('[data-rkc-notice]');
      this.panels = Array.from(root.querySelectorAll('[data-rkc-panel]'));

      // Painel aberto e o botão que o abriu — o segundo existe só para
      // devolver o foco a ele no voltar, senão o teclado cai no topo da
      // página a cada fechamento.
      this.openPanel = null;
      this.opener = null;
      this.noticeTimer = null;

      this.bind();
    }

    bind() {
      this.root.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-rkc-open]');
        if (opener && this.root.contains(opener)) {
          this.open(opener);
          return;
        }

        const back = event.target.closest('[data-rkc-back]');
        if (back && this.root.contains(back)) this.close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.openPanel) this.close();
      });

      // O add_to_cart é disparado por RGDKitPronto DEPOIS que o /cart/add.js
      // confirmou. Só reagimos com um painel nosso aberto: o mesmo evento sai
      // de qualquer seção Kit pronto da página, e fechar um painel que não
      // está aberto não significaria nada.
      document.addEventListener('rgd:kit', (event) => {
        const detail = event.detail || {};
        if (detail.action !== 'add_to_cart') return;
        if (!this.openPanel) return;

        const label = this.openPanel.dataset.rkcLabel || 'Kit';
        this.close();
        this.showNotice(label + ' adicionado à sacola.');
      });
    }

    open(opener) {
      // Comparação direta de id em vez de querySelector('#' + id): o id vem de
      // um atributo e cairia em CSS.escape para ser seletor válido. Assim a
      // busca também fica presa aos painéis desta seção.
      const wanted = opener.dataset.rkcOpen;
      const panel = this.panels.filter((candidate) => candidate.id === wanted)[0];
      if (!panel) return;

      this.hideNotice();
      if (this.grid) this.grid.hidden = true;
      panel.hidden = false;

      this.openPanel = panel;
      this.opener = opener;

      const title = panel.querySelector('[data-rkc-panel-title]');
      if (title) title.focus({ preventScroll: true });

      // A grade some e o painel entra no lugar dela. Se a seção já tinha
      // rolado para fora por cima, o cliente ficaria olhando para o meio do
      // painel — daí o reposicionamento, e só nesse caso.
      const top = this.root.getBoundingClientRect().top;
      if (top < 0) {
        this.root.scrollIntoView({ behavior: this.motion(), block: 'start' });
      }
    }

    close() {
      if (!this.openPanel) return;

      this.openPanel.hidden = true;
      if (this.grid) this.grid.hidden = false;

      const opener = this.opener;
      this.openPanel = null;
      this.opener = null;

      if (opener) opener.focus({ preventScroll: true });
    }

    motion() {
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      return reduced ? 'auto' : 'smooth';
    }

    showNotice(message) {
      if (!this.notice) return;
      this.notice.textContent = message;
      this.notice.hidden = false;
      if (this.noticeTimer) clearTimeout(this.noticeTimer);
      this.noticeTimer = setTimeout(() => this.hideNotice(), 8000);
    }

    hideNotice() {
      if (!this.notice) return;
      if (this.noticeTimer) clearTimeout(this.noticeTimer);
      this.noticeTimer = null;
      this.notice.hidden = true;
      this.notice.textContent = '';
    }
  }

  window.RGDKitCatalogo = RGDKitCatalogo;

  function initCatalogos(scope) {
    (scope || document).querySelectorAll('[data-rgd-kit-catalogo]').forEach((root) => {
      if (root.dataset.rkcReady) return;
      root.dataset.rkcReady = 'true';
      new RGDKitCatalogo(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initCatalogos(document));

  // No editor de temas a Shopify troca o DOM da section por AJAX e dispara
  // shopify:section:load — sem isto a seção fica inerte depois de qualquer
  // mudança de setting. Mesmo padrão de rgd-kit-pronto.js.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initCatalogos(event.target));
  }
})();
